<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ edit ? $t('events.programs.modification') : $t('events.programs.creation') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
              </div>
            </div>
  
            <div class="modal-body">
                <RequiredText></RequiredText>
                <div v-for="(formData, key) in formProgram.program" :key="key">
                  <CKEditor
                      labelClass="form-label fs-6 text-black"
                      :label="$t('events.programs.title')"
                      :id="`program_title_`+id"
                      container-class="mb-5"
                      :required="true"
                      :content="formData.title"
                      @text="setDescription"
                      :enableTime="true"
                  />

                  <div class="row mb-5">
                      <div class="col-12 col-md-6 col-lg-6">
                          <span class="form-label fs-6 text-black required">{{ $t('events.programs.start_time') }}</span>
                          <Input
                              :name="'start_hour_'+id"
                              type="time"
                              v-model="formData.start_time"
                          />
                      </div>
                      <div class="col-12 col-md-6 col-lg-6">
                          <span class="form-label fs-6 text-black required">{{ $t('events.programs.end_time') }}</span>
                          <Input
                              :name="'end_hour_'+id"
                              type="time"
                              v-model="formData.end_time"
                          />
                      </div>
                  </div>

                </div>
            </div>

            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingProgram"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
</template>

<script setup>
    import {ref, defineProps, watch} from 'vue'
    import CKEditor from "@/components/CKEditor.vue";
    import Button from "@/components/Button";
    import Input from "@/components/Input.vue";
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText.vue"
    import InputDate from "@/components/InputDate2.vue";

    const emits = defineEmits(["load"]);
    
    const props = defineProps({
        id: {
            type: String,
            required: true
        },
        parent: String,
        atelierId: {
            type: String,
            required: true
        },
        atelierDate: {
            type: String,
            required: true
        },
        form: {
            type: Object,
            default: {
              id: '',
              atelier_id: '',
              program: [
                {
                  title: '',
                  date: '',
                  start_time: '',
                  end_time: '',
                  description: ''
                }
              ]
            }
        },
        edit: {
            type: Boolean,
            default: false
        }
    })
  
    const store = useStore()

    const isLoadingProgram  = ref(false)
    const formProgram = ref(props.form)

    watch(() => props.form, (value) => {
        if(value) formProgram.value = value
    })
    
    function closeModal(){
      if(props.parent) $('#'+props.parent).modal('toggle')
      $('#'+props.id).modal('toggle')
    }
    
    function setDescription(text) {
        formProgram.value.program[0].title = text
    }
    
    function submitForm() {
        isLoadingProgram.value = true;
        let action = props.edit ? 'planning/updateProgram' : 'planning/createProgram'
        let message = props.edit ? 'events.programs.updated_successfully' : 'events.programs.created_successfully'

        formProgram.value.atelier_id = props.atelierId
        formProgram.value.date = props.atelierDate
        let data = formProgram.value
        if(props.edit) {
          let formData = {
            title: formProgram.value.program[0].title,
            start_time: formProgram.value.program[0].start_time,
            end_time: formProgram.value.program[0].end_time,
            id: formProgram.value.id,
            atelier_id: formProgram.value.atelier_id
          }
          data = formData
        }

        store
          .dispatch(action, data)
          .then(() => {
              isLoadingProgram.value = false;
              closeModal();
              emits('load')
              formProgram.value = {
                id: '',
                atelier_id: '',
                program: [
                  {
                    title: '',
                    date: '',
                    start_time: '',
                    end_time: '',
                    description: ''
                  }
                ]
              }
      
              window.toastr["success"](i18n.global.t(message));
          })
          .catch((e) => {
              isLoadingProgram.value = false;
          });
    }
</script>

<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>